<template>
  <div class="mb-2">
    <div v-if="title" class="text-h4">
      {{ title }}
    </div>
    <div v-if="subtitle" class="pl-1 text-subtitle-1">
      {{ subtitle }}
    </div>
    <v-btn
      class="mt-12"
      absolute top right
      fab large
      v-if="showCloseButton"
      @click="$emit('close-clicked')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    showCloseButton: {
      type: Boolean,
      default: true
    },
    search: String,
    searchButtonDisabled: Boolean
  },
  computed: {
    dialogSearch: {
      get() {
        return this.search;
      },
      set(newVal) {
        this.$emit('search-changed', newVal);
      }
    }
  }
}
</script>